import {
  CustomSegmentsData,
  SystemGeneratedSegmentNames
} from '../SegmentationMapping/segmentation-mapping-constants';

const RequiredSegmentNames = {
  CAMPAIGN_OWNERSHIP: 'Campaign Ownership',
  INCLUDE_IN_FEE_CALC: 'Include in Fee Calc'
} as const;

// Ordering should be:
// 1st - Channel
// 2nd - Platform
// 3rd - Campaign Ownership
// 4th - Include in Fee Calc
// Then all remaining values in alphabetical order.
const segmentNameToRelativeValue = (segName: string): number => {
  switch (segName) {
    case SystemGeneratedSegmentNames.CHANNEL:
      return 1;
    case SystemGeneratedSegmentNames.PLATFORM:
      return 2;
    case RequiredSegmentNames.CAMPAIGN_OWNERSHIP:
      return 3;
    case RequiredSegmentNames.INCLUDE_IN_FEE_CALC:
      return 4;
    default:
      return 99;
  }
};

export const sortSegments = (data: CustomSegmentsData[]): CustomSegmentsData[] =>
  [...data]
    .sort((a, b) => {
      const relativeDiff =
        segmentNameToRelativeValue(a.segmentName) - segmentNameToRelativeValue(b.segmentName);
      if (relativeDiff !== 0) {
        return relativeDiff;
      }
      return a.segmentName.localeCompare(b.segmentName);
    })
    .map(seg => ({
      ...seg,
      values: [...seg.values].sort((a, b) => {
        if (a.valueName === 'N/A') {
          return -1;
        }
        if (b.valueName === 'N/A') {
          return 1;
        }
        return a.valueName.localeCompare(b.valueName);
      })
    }));
